import Highcharts from 'highcharts'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { companySettingsChartColorSelector } from '../../redux/context/companySettings/selectors'
import { resolveChartColors } from '../chartColors'

export const useHighchartTheme = () => {
  const chartColors = useSelector(companySettingsChartColorSelector)
  // Stable reference so chart options built from the theme can be memoized
  return useMemo(
    () =>
      ({
        colors: resolveChartColors(chartColors),
        plotOptions: {
          column: {
            maxPointWidth: 70
          }
        },
        xAxis: {
          labels: {
            useHTML: true,
            style: {
              fontSize: '11px'
            }
          }
        },
        yAxis: {
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        legend: {
          itemStyle: {
            fontSize: '11px'
          }
        },
        chart: {
          style: {
            fontFamily: 'Manrope'
          },
          backgroundColor: undefined,
          events: {
            afterPrint() {
              // eslint-disable-next-line func-names
              Highcharts.charts.forEach(function (chart) {
                if (chart !== undefined) {
                  chart.setSize(null, null, false)
                  chart.redraw()
                }
              })
            }
          }
        },
        credits: {
          enabled: false,
          text: ''
        },
        lang: {
          decimalPoint: ',',
          thousandsSep: ' '
        }
      } satisfies Highcharts.Options),
    [chartColors]
  )
}
